export default __webpack_public_path__ + "static/media/SKJ_NEW_logo.36bf17df.png";